import { services } from "@/utils/config/services";
import { customFetch } from "../customFetch";
import { Platform } from "../platforms";

export const installers = {
  getInstaller: (id: string) => customFetch(`${services.installers}/${id}`),
  getLinuxInstallerScriptUrl: () =>
    customFetch(`${services.installers}/linux/script/url`),
  getPublicInstallers: (page: number, pageSize: number, platform: string) =>
    customFetch(
      `${services.installers}?BuildMode=Release&IsProtected=true&IsPublic=true&PageNumber=${page}&PageSize=${pageSize}&Platform=${platform}`,
    ),
  getPublicLinuxInstallers: (
    page: number,
    pageSize: number,
    distroFamily: string,
    distroVersion: string,
  ) =>
    customFetch(
      `${services.installers}?BuildMode=Release&IsProtected=true&IsPublic=true&PageNumber=${page}&PageSize=${pageSize}&Platform=${Platform.LinuxX64}&DistroFamily=${distroFamily}&DistroVersion=${distroVersion}`,
    ),
  getPublicInstallerVersions: (
    page: number,
    pageSize: number,
    platform?: Platform,
  ) => {
    let url = `${services.installers}/versions?BuildMode=Release&IsProtected=true&IsPublic=true&PageNumber=${page}&PageSize=${pageSize}`;
    if (platform) {
      url += `&Platform=${platform}`;
    } else {
      url += `&Platform=${Platform.WindowsX64}`;
    }
    return customFetch(url);
  },
};
